import { FieldError } from "@fronterahealth/frontera-ui-components/ui/field";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@fronterahealth/frontera-ui-components/ui/select";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { parseSelectContent } from "@components/ReportField/inputs/choiceContent";
import { ReportFieldInputProps } from "@components/ReportField/types";

export const ReportFieldSelect: React.FC<ReportFieldInputProps> = ({
  id,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  variant,
  ariaInvalid,
}) => {
  const result = parseSelectContent(value);

  if (!result.success) return <FieldError errors={result.error.issues} />;

  const { options, answer } = result.data;

  if (disabled) {
    return <ReportFieldDisabledValue value={answer} />;
  }

  return (
    <Select
      value={answer}
      onValueChange={(next) => {
        onChange(JSON.stringify({ options, answer: next }));
      }}
    >
      <SelectTrigger id={id} onFocus={onFocus} onBlur={onBlur} variant={variant} aria-invalid={ariaInvalid}>
        <SelectValue placeholder="--" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {answer && <SelectItem value={null}>--</SelectItem>}
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
